var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"title":_vm.$route.name,"options":_vm.options}},[_c('div',{staticClass:"expande-horizontal wrap"},_vm._l((_vm.getProducts),function(product){return _c('ProductItem',{key:product._id,attrs:{"product":product}})}),1),_c('ModalViewProduct')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }